// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  worldId: __t.string().name("world_id"),
  matchId: __t.option(__t.string()).name("match_id"),
  attackerArmyId: __t.string().name("attacker_army_id"),
  defenderArmyId: __t.string().name("defender_army_id"),
  x: __t.f64(),
  y: __t.f64(),
  status: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  resolvedAt: __t.option(__t.timestamp()).name("resolved_at"),
});
